import React from 'react';

export const ProjectForm: React.FC<any> = ({ initialData, onSubmit, onCancel }) => {
  console.log({ initialData, onSubmit, onCancel });
  return <div>Project Form</div>;
};